"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var SearchIcon = function SearchIcon() {
  return _react2.default.createElement(
    "svg",
    {
      className: "quiver-search-icon",
      width: "17px",
      height: "16px",
      viewBox: "0 0 18 17",
      version: "1.1"
    },
    _react2.default.createElement("path", {
      d: "M12.7066667,7.66813643 C12.7066667,10.8756562 10.1928831,13.4667805 7.10358025,13.4667805 C4.01385058,13.4667805 1.5,10.8757262 1.5,7.66813643 C1.5,4.46066108 4.01373787,1.87000084 7.10358025,1.87000084 C10.1929958,1.87000084 12.7066667,4.46073107 12.7066667,7.66813643 Z M11.6701918,12.3898222 L12.6929326,11.2925523 L17.2366363,15.5276371 L16.2138955,16.624907 L11.6701918,12.3898222 Z M14.2066667,7.66813643 C14.2066667,3.64227063 11.0317282,0.370000839 7.10358025,0.370000839 C3.17502413,0.370000839 0,3.64218322 0,7.66813643 C0,11.6941692 3.17509965,14.9667805 7.10358025,14.9667805 C11.0316527,14.9667805 14.2066667,11.6940818 14.2066667,7.66813643 Z",
      stroke: "none",
      fill: "#FFFFFF",
      fillRule: "nonzero"
    })
  );
};

exports.default = SearchIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SearchIcon/SearchIcon.js
// module id = 322
// module chunks = 0